// @flow

import { type IncomingPayment } from './types';
import type { Country } from '@tectonics/prs/country';

export function getCountry(incomingPayment: IncomingPayment): Country {
  return incomingPayment['country'];
}
